import {
  Routes,
  Route
} from "react-router-dom";

import LoginPage from './LoginPage';
import FileUploadPage from './FileUploadPage';
import BatchFileUploadPage from "./BatchFileUploadPage";
import ControlPanel from "./ControlPanel";
import FileList from "./FileList";
import ConfigurationPage from "./ConfigurationPage";
import UsageData from "./UsageData";
import FileProcessed from "./FileProcessed";
import FileProcessedScore from "./FileProcessedScore";
import AskDataPage from "./AskDataPage";

function App() {
  return (
    <div className="App">
      <Routes>
        <Route index element={<LoginPage />} />
        <Route path="fileupload" element={<FileUploadPage />} />
        <Route path="batchfileupload" element={<BatchFileUploadPage />} />
        <Route path="fileprocessed/:itemId" element={<FileProcessed />} />
        <Route path="fileprocessedScore/:itemId" element={<FileProcessedScore />} />
        <Route path="controlpanel" element={<ControlPanel />} />
        <Route path="filelist" element={<FileList />} />
        <Route path="askdata" element={<AskDataPage />} />
        <Route path="configuration" element={<ConfigurationPage />} />
        <Route path="usagedata" element={<UsageData />} />
        <Route path="*" element={<LoginPage />} />
      </Routes>
    </div>
  );
}

export default App;
